"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpotShiftStore = useSpotShiftStore;
const vue_1 = require("vue");
const provider_1 = require("../provider");
function useSpotShiftStore() {
    const store = (0, vue_1.inject)(provider_1.spotShiftStoreKey);
    if (!store) {
        throw new Error("SpotShiftStore not provided");
    }
    return store;
}
